import { render, staticRenderFns } from "./roomInfoModule3.vue?vue&type=template&id=1850ca03&scoped=true"
import script from "./roomInfoModule3.vue?vue&type=script&lang=js"
export * from "./roomInfoModule3.vue?vue&type=script&lang=js"
import style0 from "./roomInfoModule3.vue?vue&type=style&index=0&id=1850ca03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850ca03",
  null
  
)

export default component.exports